// extracted by mini-css-extract-plugin
module.exports = {"PageTemplate":"PageTemplate_PageTemplate__3ur_A"};